import { useContext } from "react";
import { getById } from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../api/useAdminDeliveryEndpointApi";
import { DeliveryEndpointContext } from "../../context/DeliveryEndpointContext";
import { EditAsperaDeliveryEndpointFormInputs } from "./EditAsperaDeliveryEndpointForm";

export const useEditAsperaDeliveryEndpointForm = (deliveryEndpointId: string) => {
    const { updateDeliveryEndpoint } = useAdminDeliveryEndpointApi();

    const { deliveryEndpointItems, updateAsperaDeliveryEndpointItem } = useContext(DeliveryEndpointContext);

    const deliveryEndpoint = getById(deliveryEndpointItems, deliveryEndpointId);

    const editDeliveryEndpoint = async ({
        name,
        url,
        user,
        ssmPrivateKeyName,
        workspace
    }: EditAsperaDeliveryEndpointFormInputs): Promise<void> => {
        await updateDeliveryEndpoint({
            id: deliveryEndpointId,
            name,
            url,
            user,
            ssmPrivateKeyName,
            type: DeliveryEndpointType.Aspera,
            workspace
        });

        updateAsperaDeliveryEndpointItem({
            id: deliveryEndpointId,
            name,
            details: { type: DeliveryEndpointType.Aspera, url, user, ssmPrivateKeyName, workspace },
            type: DeliveryEndpointType.Aspera,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        deliveryEndpoint,
        editDeliveryEndpoint
    };
};
